
import { Component, Emit, Vue, Prop, Watch } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

interface CheckboxIconValues {
    check: string[]
    uncheck: string[]
}

@Component({
    components: {
        FontAwesomeIcon,
    },
})
export default class AppCheckbox extends Vue {
    @Prop({
        default: () => {
            return {
                check: ['fas', 'check-square'],
                uncheck: ['far', 'square'],
            }
        },
    }) public icons!: CheckboxIconValues

    @Prop({ default: false }) public center!: boolean
    @Prop({ default: false }) public value!: boolean
    private isChecked: boolean = this.value

    get color(): string {
        return '#F57C00'
    }

    get icon(): string[] {
        return this.isChecked ? this.icons.check : this.icons.uncheck
    }

    @Watch('value')
    private getValue() {
        this.isChecked = this.value
    }

    private unwrappedValue() {
        return this.isChecked ? this.isChecked : false
    }

    @Emit('input')
    private onInputChanged() {
        this.isChecked = !this.unwrappedValue()
        return this.isChecked
    }

    private onToggle() {
        this.onInputChanged()
    }
}
